import _ from 'lodash';
import { uuid2 as uuid } from '@/utils';

class GraphicBase {
  constructor(payload, stage) {
    this.id = payload.id ? payload.id : uuid();
    this.data = payload.data;
    this.property = payload.property;

    this.ele = null;
    this.layer = null;
    this.canDraggable = false;
    this.stage = stage;

    this.build();
  }

  // eslint-disable-next-line class-methods-use-this
  updateEle() { }

  // eslint-disable-next-line class-methods-use-this
  setSelected(selected) { }

  update(target) {
    this.property = _.extend(this.property, target.property);
    // this.ele.destroy();
    // this.build();
    this.stage.changeTransformNodes(this.ele);
    if (this.stage.state === 'select') {
      if (this.canDraggable) {
        this.ele.draggable(true);
      }
    }
  }

  toObject() {
    return {
      graphic_data: _.cloneDeep(this.data),
      graphic_id: this.id,
      property: _.cloneDeep(this.property),
    };
  }
}

export default GraphicBase;
